import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchComponent } from '../../components/common/search/search.component';
import { CompetitorSearchModel, CompetitorDto } from '../../models/competitors/competitor.models';
import { CompetitorService } from '../../services/competitor.service';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { BaseCompetitorsComponent } from './base.competitors.component';
import { BlockUI } from 'ng-block-ui';

@Component({
    selector: 'add-competitors',
    template: require('./add.competitors.component.html'),
    styles: [require('./add.competitors.component.css')]
})
export class AddCompetitorsComponent extends SearchComponent<CompetitorSearchModel, CompetitorDto>{

    base: BaseCompetitorsComponent;

    viewedCompany: string;

    @BlockUI('competitor-search-block') private paramsBlock;

    @ViewChild('viewCompetitorModal2', { static: false }) private viewCompetitorModal: any;

    @Output() onAdd = new EventEmitter<any>();

    constructor(private readonly competitorService: CompetitorService, configuration: Configuration, helpers: Helpers,) {
        super(new CompetitorSearchModel(configuration), competitorService, helpers);

        this.request.pageSize = 30;
        this.request.pageNumber = 0;
    }

    addCompetitor(competitorname: string) {
        this.competitorService.add(competitorname).subscribe((response: any) => {
            this.onAdd.emit();
            this.search();
            this.paramsBlock.stop();
        });
    }

    view(name: string) {
        this.viewCompetitorModal.showAndPopulate(name);
    }

    search() {
        this.paramsBlock.start();
        this.request.pageSize = 30;
        this.request.pageNumber = 0;
        return super.search();
    }

    searchCallback(results) {
        super.searchCallback(results);
        this.paramsBlock.stop();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/add.competitors.component.ts